import MbpAthnUi from "./MbpAthn";
import { useLocation,useNavigate } from "react-router-dom";
import "Assets/css/PrntAthn.css";
import { ChangeEvent, useState } from "react";
import { useEffect } from "react";
import MbpAthnRsltVrfRqstApi from "Apis/MbpAthnRsltVrfRqstApi";

declare global {
    interface Window { kmcRespFunc: any; }
}
const PrntAthnUi = () => {
    const location= useLocation();  
    const navigate = useNavigate();
    const serchParamsFunc = () => {
        return new URLSearchParams(location.search);
    }
    let query =serchParamsFunc();
    let getAthnTypeCd = query.get("athnTypeCd");
    const [agreChkState,setAgreChkState] = useState<string[]>([]);
    const AgreTrmsFunc = (e:ChangeEvent<HTMLInputElement>) => {
            if(e.target.name =="agreAll") {
                e.target.checked
                ? setAgreChkState(["agreStipulation","agrePrivacy"])
                : setAgreChkState([]);
            }else {
                e.target.checked
                ? setAgreChkState([...agreChkState,e.target.name])
                : setAgreChkState(agreChkState.filter((choice)=> choice !== e.target.name));
            }
        }
    useEffect(() => {
        function kmcRespFunc (kmcApiTknrslt:string,kmcApiCertNumrslt:string){
            MbpAthnRsltVrfRqstApi(kmcApiTknrslt,kmcApiCertNumrslt)
            .then((resp) => {
                console.log(resp);
                switch (resp.apiBody.athnPrpsCd) {
                    case "tmChse":
                        navigate("/GameTimePicker", { replace: true });
                    break;

                }   
            });
        }      
        window.kmcRespFunc = kmcRespFunc; 
    },[]);
    return (
        <div className="BgW">
            <div className="container800">
                <div className="tCenter pt120 prntAthnTitl">
                    <h1>게임 시간 선택제 신청하기</h1>
                    <p className="colR">※ 신청자가 법정대리인이 아닐 경우 관련법에 따라 민·형사상 책임을 부담하게 될 수 있습니다.</p>
                </div> 
                <div className="prntAthnTrmsWrap" >
                    <span>법정대리인 개인정보 수집 및 이용 동의</span>
                    <ul>
                        <li><p>개인정보 수집, 이용 항목 : 성명, 생년월일, 성별, 내외국인, CI정보</p></li>
                        <li><p>개인정보 수집, 이용 목적 : 자녀의 게임시간 선택제 서비스 이용을 위한 법정대리인 본인확인</p></li>
                        <li><p>개인정보 보유 및 이용기간 : 게임시간 선택제 해지 요청 또는 자녀의 성년 도래 시 파기</p></li>
                        <li><p>법정대리인은 위의 개인정보 수집,이용에 대한 동의를 거부하실 권리가 있으나,<br/>동의를 거부할 경우 게임시간 선택제 서비스 이용에 제한을 받으실 수 있습니다.</p></li>
                    </ul>
                </div>
                <div>
                    <ul className="prntAthnAgreeWrap">
                        <li>
                            <input type="checkbox" name="prntAthnAgree" id="prntAthnAgree" onChange={AgreTrmsFunc}/>
                            <label htmlFor="prntAthnAgree" className="colR">신청자는 법적 보호자이고, 법적 보호자가 아닌 것이 밝혀질 시 관계 법령에 따라 처벌을 받을 수 있음을 확인합니다. (필수)</label>
                        </li>
                        <li>
                            <input type="checkbox" name="prntTrmsAgree" id="prntTrmsAgree" onChange={AgreTrmsFunc}/>
                            <label htmlFor="prntTrmsAgree">
                            상기 내용을 충분히 이해하였으며, 개인정보 별도 제공에 대해 동의합니다. (필수)
                            </label>
                        </li>
                    </ul>
                </div>
                <div className="prntAthnBtnWrap">
                    {agreChkState.length == 2?
                        <MbpAthnUi athnPrpsCd={"PRNT_ATHN"} AthnTxt={'법정 대리인 본인인증'} loginId={null} ChkFunc={null} BtnClass="" className="tCenter"/>
                        :
                        <div className='nextPageBtn disable'>
                            <span>법정 대리인 본인인증</span>
                        </div>
                    }
                </div>

            </div>
        </div>
    )
}
export default PrntAthnUi;